import { Injectable } from "@angular/core";
import { AuthService, IdToken } from "@auth0/auth0-angular";
import { JwtHelperService } from "@auth0/angular-jwt";
import { map, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(private authService: AuthService, private jwtHelper: JwtHelperService) { }

  public hasFeatureFlag(featureFlag: keyof typeof FeatureFlag): Observable<boolean> {
    const featureFlagValue = FeatureFlag[featureFlag];
    return this.authService.idTokenClaims$.pipe(
      switchMap((idToken: IdToken | null | undefined) => {
        if (idToken && idToken!['data']['featureFlagIds']) {
          return of((<number[]>idToken!['data']['featureFlagIds']).includes(featureFlagValue));
        }

        return this.authService.getAccessTokenSilently();
      }), map((result) => {
        if (typeof result === 'boolean') return result;
        const oldFeatureFlagValue = OldFeatureFlag[featureFlag];
        const decodedToken = this.jwtHelper.decodeToken(result);
        if (decodedToken["authorization-data"] != undefined
          && decodedToken["authorization-data"]['feature_flags'] != undefined) {
          return decodedToken["authorization-data"]['feature_flags'].includes(oldFeatureFlagValue);
        }
        return false;
      }));
  }
}

export enum OldFeatureFlag {
  HasAccessToShell = 'hasAccessToShell',
  ProductShellNewNavigation = 'Product_Shell_NewNavigation',
  ProductShellSpeedBooksButton = 'Product_Shell_SpeedBooksButton',
  Venture_Fiscaal_Inkomstenbelasting ='Venture_Fiscaal_Inkomstenbelasting',
  aVenture_Fiscaal_Inkomstenbelasting = 'aVenture_Fiscaal_Inkomstenbelasting',

}

export enum FeatureFlag {
  HasAccessToShell = 220,
  ProductShellNewNavigation = 276,
  ProductShellSpeedBooksButton = 290,
  Venture_Fiscaal_Inkomstenbelasting = 709,
  aVenture_Fiscaal_Inkomstenbelasting = 2435,
  // Venture_Fiscaal_Inkomstenbelasting = 791
}
